export default "__VITE_ASSET__73475fa1__"